import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useEffect, useState } from 'react'
import ParticleBackground from './components/ParticleBackground'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import HomePage from './pages/Home'
import AboutPage from './pages/About'
import ProductsPage from './pages/Products'
import SolutionsPage from './pages/Solutions'
import NewsPage from './pages/News'

function App() {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 1000)
    return () => clearTimeout(timer)
  }, [])

  if (isLoading) {
    return (
      <div className="min-h-screen bg-deep-blue flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-tech-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-white/70">加载中...</p>
        </div>
      </div>
    )
  }

  return (
    <Router>
      <div className="relative min-h-screen">
        <ParticleBackground />
        <div className="relative z-10">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/solutions" element={<SolutionsPage />} />
              <Route path="/news" element={<NewsPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </div>
    </Router>
  )
}

export default App
